import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  heading: {
    id: '6ZJQnI',
    description: 'Heading for defer buy now modal',
    defaultMessage: 'Not Ready to Select a Plan Yet?',
  },
  subheading: {
    id: 'tWpSFB',
    description: 'Subheading for defer buy now modal',
    defaultMessage: 'Take up to 30 days to explore all ShipStation features',
  },
  trialIncludesHeading: {
    id: '44FQG7',
    description: 'Heading for trial features section',
    defaultMessage: 'YOUR FREE TRIAL INCLUDES:',
  },
  powerfulAutomationTitle: {
    id: 'DDgMMF',
    description: 'Title for powerful automation feature',
    defaultMessage: 'Powerful Automation',
  },
  powerfulAutomationDescription: {
    id: 'RqZ2G4',
    description: 'Description for powerful automation feature',
    defaultMessage: 'Save time and money on every shipment',
  },
  customAnalyticsTitle: {
    id: 'aN4HOp',
    description: 'Title for custom analytics feature',
    defaultMessage: 'Custom Analytics',
  },
  customAnalyticsDescription: {
    id: 'XqSxv3',
    description: 'Description for custom analytics feature',
    defaultMessage: 'Get deep insights to grow your business',
  },
  inventoryWarehouseTitle: {
    id: 'ZQnW/f',
    description: 'Title for inventory and warehouse feature',
    defaultMessage: 'Inventory & Warehouse',
  },
  inventoryWarehouseDescription: {
    id: 'ZUuG2s',
    description: 'Description for inventory and warehouse feature',
    defaultMessage: 'Optimize inventory, reordering, picking, and more',
  },
  returnsExchangesTitle: {
    id: '4ABpMq',
    description: 'Title for returns and exchanges feature',
    defaultMessage: 'Returns & Exchanges',
  },
  returnsExchangesDescription: {
    id: 'HAfjKW',
    description: 'Description for returns and exchanges feature',
    defaultMessage: 'Create better customer experiences and retain revenue',
  },
  backToPlanButton: {
    id: '7smto/',
    description: 'Button text to go back to plan selection',
    defaultMessage: 'Back to Select a Plan',
  },
  startTrialButton: {
    id: '/iJ1uw',
    description: 'Button text to start free trial',
    defaultMessage: 'Start Free Trial',
  },
  disclaimer: {
    id: '09QTfn',
    description: 'Disclaimer text about upgrading and credit card',
    defaultMessage: 'You can upgrade to a paid plan at any time. No credit card required to start your trial.',
  },
  closeButton: {
    id: '9IDWMU',
    description: 'Close button aria label',
    defaultMessage: 'Close',
  },
  errorSavingProgress: {
    id: 'o3Kpg2',
    description: 'Error notification shown when unable to save Buy Now flow progress',
    defaultMessage: 'Unable to save your progress. Please try again.',
  },
});
